import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { LoadingService } from '@app/shared/loading-service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingGuard implements CanActivate {
  constructor(private loadingService: LoadingService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    this.loadingService.show();
    setTimeout(() => {
      this.loadingService.hide();
    }, 300);

    return true;
  }
}
